<mat-dialog-actions class="justify-content-between">
    <h4 class="f-s-16 f-w-600">@if(userDatafill){
        <h3>{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.USER' | translate }}</h3>
        }@else{
        <h3>{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.USER' | translate }}</h3>
        }
    </h4>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<div *ngIf="isLoading" class="loader-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="userForm">
        <mat-tab-group mat-stretch-tabs="false" [color]="'primary'">
            <mat-tab label="User Details">

                <div class="row m-t-10">
                    <div class="col-lg-12">
                        <div class="d-flex align-items-center m-b-16 m-l-5">
                            <div class="flex flex-col items-center relative" id="avatar-container"
                                (mouseenter)="showAddPhotoOverlay=true">
                                <!--  (mouseleave)="showAddPhotoOverlay=false" -->
                                <img class="avatar-photo" #avatarImg [src]="avatarSrc" id="avatar-photo"
                                    alt="User avatar" fallbackImage="assets/images/profile/user-1.jpg">


                                <div *ngIf="showAddPhotoOverlay" id="add-photo-overlay" class="avatar-photo"
                                    style="text-align: center;">
                                    <!-- Hover Button -->
                                    <button id="add-avatar-photo-button" class="center-positon-absolute" mat-icon-button
                                        [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                                        (mouseenter)="openMenu(menuTrigger)">
                                        <mat-icon>add_a_photo</mat-icon>
                                    </button>

                                    <!-- Hover Menu -->
                                    <mat-menu #menu="matMenu" (closed)="onMenuClosed()">
                                        <button mat-menu-item (click)="takePhotoOnWebCamera()">
                                            {{ 'LABEL.TAKE_PHOTO' | translate }}
                                            <mat-icon>photo_camera</mat-icon>
                                        </button>
                                        <button mat-menu-item (click)="fileInput.click();showAddPhotoOverlay=false">
                                            {{ 'LABEL.BROWSER_PHOTO' | translate }}
                                            <mat-icon>collections icon</mat-icon>
                                        </button>
                                    </mat-menu>

                                </div>

                            </div>
                            <input #fileInput type="file" (change)="onFileChanged($event)" name="avatar"
                                accept="image/png, image/jpeg" style="display:none;">
                        </div>
                    </div>
                </div>

                <div class="row m-t-10">
                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.FIRSTNAME_LABEL' | translate }}</mat-label>
                            <input matInput placeholder="First Name" formControlName="firstname">
                            <mat-error *ngIf="userForm.get('firstname')?.hasError('invalidName')">
                                {{ 'VALIDATION.ALPHABETS' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('firstname')?.hasError('required')">
                                {{ 'REQUIRED.NAME' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('firstname')?.hasError('maxlength')">
                                {{ 'REQUIRED.MAXIMUM_20' | translate }}
                            </mat-error>
                        </mat-form-field>

                    </div>
                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.LASTNAME_LABEL' | translate }}</mat-label>
                            <input matInput placeholder="Last Name" formControlName="lastname">
                            <mat-error *ngIf="userForm.get('lastname')?.hasError('invalidName')">
                                {{ 'VALIDATION.ALPHABETS' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('lastname')?.hasError('required')">
                                {{ 'REQUIRED.NAME' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('lastname')?.hasError('maxlength')">
                                {{ 'REQUIRED.MAXIMUM_20' | translate }}
                            </mat-error>
                        </mat-form-field>

                    </div>

                </div>

                <div class="row m-t-10">

                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.DOB_LABEL' | translate }}</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="birthDate" [min]="minDate"
                                [max]="maxDate" readonly (click)="picker.open()" (focus)="picker.open()">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
                            <mat-error *ngIf="userForm.get('birthDate')?.hasError('required')">
                                {{ 'REQUIRED.SELECT_DATE' | translate }}
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.JOINDATE_LABEL' | translate }}</mat-label>
                            <input matInput [matDatepicker]="pickerjoin" formControlName="joinDate" [min]="minDate"
                                [max]="maxDate" readonly (click)="pickerjoin.open()" (focus)="pickerjoin.open()">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="pickerjoin"></mat-datepicker-toggle>
                            <mat-datepicker #pickerjoin [color]="'primary'"></mat-datepicker>
                            <mat-error *ngIf="userForm.get('joinDate')?.hasError('required')">
                                {{ 'REQUIRED.SELECT_DATE' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row m-t-10">
                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}</mat-label>
                            <textarea matInput placeholder="Address" cols="2" rows="3"
                                formControlName="address"></textarea>
                            <mat-error *ngIf="userForm.get('address')?.hasError('maxlength')">
                                {{ 'REQUIRED.MAXIMUM255' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.PHONE_LABEL' | translate }}</mat-label>
                                    <input matInput placeholder="Phone No" formControlName="phoneNumber" maxlength="10"
                                        appAllowOnlyDigits>
                                    <mat-error
                                        *ngIf="userForm.get('phoneNumber')?.hasError('required') && (userForm.get('phoneNumber')?.dirty || userForm.get('phoneNumber')?.touched)">
                                        {{ 'REQUIRED.NAME' | translate }}
                                    </mat-error>

                                    <mat-error
                                        *ngIf="userForm.get('phoneNumber')?.hasError('minlength') || userForm.get('phoneNumber')?.hasError('maxlength')">
                                        {{ 'REQUIRED.MINIMUM10' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.EMAIL_LABEL' | translate }}</mat-label>
                                    <input matInput placeholder="eg.xyz@gmail.com" formControlName="email">
                                    <mat-error *ngIf="userForm.get('email')?.hasError('required')">
                                        {{ 'REQUIRED.NAME' | translate }}
                                    </mat-error>
                                    <mat-error *ngIf="userForm.get('email')?.hasError('invalidEmail')">
                                        {{ 'VALIDATION.EMAIL' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>


                    </div>
                </div>

                <div class="row m-t-10">
                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.PAN_LABEL' | translate }}</mat-label>
                            <input matInput [type]="hidePan ? 'password' : 'text'"
                                placeholder="{{ 'LABEL.PAN_LABEL' | translate }}" formControlName="panNumber"
                                maxlength="10" minlength="10">
                            <button mat-icon-button matSuffix type="button" (click)="hidePan = !hidePan">
                                <mat-icon class="icon-eye">{{ hidePan ? 'visibility' : 'visibility_off' }}</mat-icon>
                            </button>
                            <mat-error *ngIf="userForm.get('panNumber')?.hasError('required')">
                                {{ 'REQUIRED.NAME' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('panNumber')?.hasError('invalidPan')">
                                {{ 'VALIDATION.PAN_NUMBER' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('panNumber')?.hasError('maxLength')">
                                {{ 'REQUIRED.MAXIMUM10' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('panNumber')?.hasError('minLength')">
                                {{ 'REQUIRED.MINIMUM10' | translate }}
                            </mat-error>

                        </mat-form-field>
                    </div>

                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.AADHAR_LABEL' | translate }}</mat-label>
                            <input matInput [type]="hideAadhaar ? 'password' : 'text'"
                                placeholder="{{ 'LABEL.AADHAR_LABEL' | translate }}" formControlName="aadhaarNumber"
                                maxlength="12" appAllowOnlyDigits>
                            <button mat-icon-button matSuffix type="button" (click)="hideAadhaar = !hideAadhaar">
                                <mat-icon class="icon-eye">{{ hideAadhaar ? 'visibility' : 'visibility_off'
                                    }}</mat-icon>
                            </button>
                            <mat-error
                                *ngIf="userForm.get('aadhaarNumber')?.hasError('required') && (userForm.get('aadhaarNumber')?.dirty || userForm.get('aadhaarNumber')?.touched)">
                                {{ 'REQUIRED.NAME' | translate }}
                            </mat-error>

                            <mat-error
                                *ngIf="userForm.get('aadhaarNumber')?.hasError('minlength') || userForm.get('aadhaarNumber')?.hasError('maxlength')">
                                {{ 'REQUIRED.MINIMUM12' | translate }}
                            </mat-error>

                        </mat-form-field>
                    </div>
                </div>

                <div class="row m-t-10" *ngIf="!userDatafill">
                    <div class="col-lg-4">
                        <mat-form-field appearance="outline" class="w-100 ">
                            <mat-label>{{ 'LABEL.SELECT_ROLE' | translate }}</mat-label>
                            <mat-select formControlName="role">
                                @for (user of userRole; track user) {
                                <mat-option [value]="user">{{user}}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="userForm.get('role')?.hasError('required')&&
                                        (userForm.get('role')?.dirty || userForm.get('role')?.touched)">
                                {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.USERNAME' | translate }}</mat-label>
                            <input matInput placeholder="User Name" formControlName="username">
                            <mat-error mat-error
                                *ngIf="userForm.get('username')?.hasError('required') && (userForm.get('username')?.dirty || userForm.get('username')?.touched)">
                                {{ 'REQUIRED.NAME' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('username')?.hasError('minlength')">
                                {{ 'REQUIRED.MINIMUM3' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4" *ngIf="!userDatafill">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.PASSWORD_LABEL' | translate }}</mat-label>

                            <input matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Enter password"
                                formControlName="password">

                            <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button">
                                <mat-icon class="icon-eye">{{ hidePassword ? 'visibility' : 'visibility_off'
                                    }}</mat-icon>
                            </button>

                            <mat-error *ngIf="userForm.get('password')?.hasError('required')">
                                {{ 'REQUIRED.PASSWORD_REQUIRE' | translate }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('password')?.hasError('minlength')">
                                {{ 'VALIDATION.PASSWORD_MUST' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row m-t-10" *ngIf="isDoctor">
                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.DEGREE' | translate }}</mat-label>
                            <input matInput placeholder="{{ 'LABEL.DEGREE' | translate }}" formControlName="degree">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6">
                        <mat-form-field appearance="outline" class="w-100 ">
                            <mat-label>{{ 'ENTITY.SPECIALITY' | translate }}</mat-label>
                            <mat-select formControlName="specialityId">
                                <mat-option class="f-s-16 f-w-600" (click)="onAddSpeciality()">
                                    Add Speciality
                                </mat-option>
                                @for (speciality of DoctorSpeciality; track speciality) {
                                <mat-option [value]="speciality.id">{{speciality.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Availability" *ngIf="isDoctor">
                <app-availability #availabilityComp (availability)="avalibilityCheck($event)" [userId]="userid">
                </app-availability>
            </mat-tab>
        </mat-tab-group>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row">
        <div class="col-lg-9"></div>
        <div class="col-lg-3 d-flex justify-content-end">
            <button mat-stroked-button (click)="onCloseDialog()" class="m-r-6">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>
            @if(userDatafill){
            <button mat-flat-button color="primary" class="m-l-7" (click)="onUserUpdate()">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            }@else {
            <button mat-flat-button color="primary" class="m-l-7" (click)="onSaveUser()" [disabled]="userForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            }
        </div>

    </div>
</mat-dialog-actions>